<script>
    import { onMount } from "svelte";
    import { Link, useLocation } from "svelte-navigator";
    import { api, cart } from "./stores";

    let location = useLocation();
    let operation;
    let cartCount;
    $: cartCount = $cart.count;

    onMount(async () => {
        $api.getOperation().then(
            (result) => {
                operation = result;
            },
            (err) => {
                console.error(err);
            }
        );
    });
</script>

{#if operation}
    <div id="right-menu">
        <!-- <Link to="">
            <div
                id="home"
                class="right-menu-entry {$location.pathname.split('/').length ==
                    4 || $location.pathname.split('/')[4] == 'catalog'
                    ? 'selected'
                    : ''}"
            >
                <div class="right-menu-icon icon">
                    <i class="fas fa-2x fa-home" />
                </div>
                <div class="right-menu-label">
                    <span>Accueil</span>
                </div>
            </div>
        </Link>
        {#if !operation.is_paf}
            <Link to="products">
                <div
                    id="rayons-right-menu"
                    class="right-menu-entry {$location.pathname.split('/')[4] ==
                    'products'
                        ? 'selected'
                        : ''}"
                >
                    <span class="right-menu-icon icon">
                        <i
                            class="fas fa-percent {$location.pathname.split(
                                '/'
                            )[4] == 'products'
                                ? 'is-orange'
                                : ''}"
                        />
                    </span>
                    <div class="right-menu-label">
                        <span>Les promotions</span>
                    </div>
                </div>
            </Link>
        {/if} -->

        {#if $location.pathname.split("/")[1] == "admin"}
            <Link to="/admin">
                <div id="catalog-right-menu" class="right-menu-entry">
                    <div class="right-menu-icon icon">
                        <i class="fas fa-2x fa-user-cog" />
                    </div>
                    <div class="right-menu-label">
                        <span>Retour</span>
                    </div>
                </div>
            </Link>
        {/if}
    </div>

    <!-- <div id="mobile-menu" class={operation.is_paf ? "only-three" : ""}>
        <Link to="">
            <div
                class="menu-item {$location.pathname.split('/').length == 4 ||
                ($location.pathname.split('/')[4] == 'catalog' &&
                    operation.is_paf)
                    ? 'selected'
                    : ''}"
            >
                <span class="icon">
                    <i class="fa fa-2x fa-home" />
                </span>
                <span class="menu-item-label">Accueil</span>
            </div>
        </Link>

        {#if !operation.is_paf}
            <Link to="products">
                <div
                    class="menu-item {$location.pathname.split('/')[4] ==
                    'products'
                        ? 'selected'
                        : ''}"
                >
                    <span class="icon">
                        <i
                            class="products {$location.pathname.split('/')[4] ==
                            'products'
                                ? 'is-orange'
                                : ''}"
                        />
                    </span>
                    <span class="menu-item-label">Les promotions</span>
                </div>
            </Link>
        {/if}

        {#if operation && operation.documentUid !== "1984f5110e75bd5bb0237c21d9993fea"}
            <Link to="catalog/1">
                <div
                    id="cart"
                    class="menu-item {$location.pathname.split('/')[4] ==
                    'catalog'
                        ? 'selected'
                        : ''}"
                >
                    <span class="icon">
                        <i
                            class="fas fa-2x fa-book-open {$location.pathname.split(
                                '/'
                            )[4] == 'cart'
                                ? 'is-orange'
                                : 'is-blue'}"
                        />
                    </span>
                    <span class="menu-item-label">Feuilletable</span>
                </div>
            </Link>
        {/if}

        <Link to="cart">
            <div
                id="cart"
                class="menu-item {$location.pathname.split('/')[4] == 'cart'
                    ? 'selected'
                    : ''}"
            >
                <span class="icon">
                    <i
                        class="list {$location.pathname.split('/')[4] == 'cart'
                            ? 'is-orange'
                            : 'is-blue'}"
                    />
                </span>
                <span class="menu-item-label">Mon mémo</span>
                {#if $cartCount > 0}
                    <span id="cart-counter">
                        {$cartCount}
                    </span>
                {/if}
            </div>
        </Link> -->

    <!-- <Link to="others">
            <div class="menu-item {$location.pathname.split('/')[4] == 'others' ? 'selected' : ''}">
                <span class="icon">
                    <i class="fas fa-2x fa-copy"></i>
                </span>
                <span class="menu-item-label">Les catalogues</span>
            </div>
        </Link> -->
    <!-- </div> -->
{/if}

<style lang="scss">
    @import "./styles/variables.scss";

    #right-menu {
        width: $right-space;
        position: fixed;
        right: 0;
        top: 90px;
        .right-menu-entry:hover {
            text-decoration: none;
        }
        .right-menu-entry {
            &.selected {
                .right-menu-icon,
                .right-menu-label {
                    color: $orange;
                }
            }

            cursor: pointer;
            display: block;
            background-color: white !important;
            padding: 10px;
            margin: 10px;
            margin-right: 0;
            border-top-left-radius: 6px;
            border-bottom-left-radius: 6px;

            .right-menu-icon,
            .right-menu-label {
                display: inline-block;
                color: $blue;
                vertical-align: middle;
                text-transform: uppercase;
                font-size: 13px;
                font-weight: 500;
            }

            .right-menu-icon {
                width: 30px;
                height: 30px;
                i {
                    width: 100%;
                    height: 100%;
                }
            }
        }

        #errata-menu {
            background-color: white;
            margin-top: -15px;
            margin-left: 10px;
            border-bottom-left-radius: 6px;
            float: left;
            width: calc(100% - 10px);
        }
    }

    #mobile-menu {
        display: none;
    }

    @media (max-width: $mobile-breakpoint) {
        #right-menu {
            display: none;
        }
        #mobile-menu {
            border-top: 1px solid $grey-light;
            display: block;
            position: fixed;
            bottom: 0;
            left: 0;
            width: 100%;
            height: $menu-mobile-height;
            background-color: white;

            &.only-three {
                .menu-item {
                    width: 33.33%;
                }
            }

            .menu-item {
                width: 25%;
                height: 100%;
                text-align: center;
                display: inline-block;
                float: left;
                color: $blue;
                border-right: 1px solid $grey-light;

                &.selected {
                    color: $orange;
                }

                .icon,
                .menu-item-label {
                    display: block;
                    float: left;
                    width: 100%;
                    font-size: 12px;
                    font-weight: bold;
                    margin-top: 10px;
                }

                .menu-item-label {
                    margin-top: 5px;
                }
            }

            #cart {
                position: relative;
                #cart-counter {
                    background-color: $orange;
                    color: white;
                    position: absolute;
                    top: 5px;
                    left: 65px;
                    width: 25px;
                    height: 25px;
                    border-radius: 50%;
                    vertical-align: middle;
                    text-align: center;
                }
            }
        }
    }
</style>
